module.exports = {"Installion Of Threaded Inserts":"Installation Of Threaded Inserts","Nut Plates":"Nut Plates","Bushings":"Bushings","Other Hardware":"Other Hardware"}


//////////////////
// WEBPACK FOOTER
// ./src/config/assemblyMethods.json
// module id = 5678
// module chunks = 1